import { RootState } from '../../RootState';
import { StateCart } from '../CartsState';
import selectCarts from './selectCarts';

const selectHomeDeliveryCart = (state: RootState): StateCart | null =>
  selectCarts(state).HOME_DELIVERY ?? null;

export default selectHomeDeliveryCart;
